module.exports = __webpack_public_path__ + "img/fif-welcome.89dc1f19.png";